// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"998405cb","453":"95bb4c8d","732":"e4ccf62b"}[chunkId] + ".chunk.js";
};